const RANKING_YEAR_TRANSITIONS: Record<string, { month: number; day: number }> = {
  CRO: { month: 8, day: 1 },
  ROA: { month: 10, day: 20 },
  DEFAULT: { month: 1, day: 1 },
};

export default RANKING_YEAR_TRANSITIONS;
